import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for PWA support.
// Change to serviceWorkerRegistration.unregister() to disable.
serviceWorkerRegistration.register();
